
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import { mergeStyleSets } from 'office-ui-fabric-react/lib/Styling';

import {
    sagas as sagasMap,
    MapInContainer,
    getLayerIdFromFeatureForData
} from '../../map';
import appGetActions from '../../app/saga';
import { sagas as sagasMeasurement } from '../../measurement';
import { getMapLayers } from '../../project';
import getAppModules from './getAppModules';
import DialogObjectInfo from './DialogObjectInfo';

/**
 * Viewer containing 2D map window.
 *
 * @reactProps {Object} projectDefinition - project definition
 * @reactProps {Object} appLayoutProps - properties for customize layout
 * @reactProps {Object} map - actual map state
 */
class MapBasicViewer extends Component {

    classNames = mergeStyleSets({
        root: {

        },
    });

    getAppModules() {
        return getAppModules(this.props.projectDefinition);
    }

    handleChangeView = (center, zoom, rotation, resolution) => {
        this.props.mapActions.changeView(center, zoom, rotation, resolution);
    }

    handleFeatureClick = async (feature) => {
        let layerId = getLayerIdFromFeatureForData(feature);
        if (layerId) {
            await DialogObjectInfo.show(
                getMapLayers(this.props.project),
                layerId,
                feature.getProperties(),
                this.props.projectDefinition.app
            );
        }
    }

    handleFeaturesFind = async (features, finished, coordinates) => {
        let objects = features.map(item => {
            return {
                layerId: getLayerIdFromFeatureForData(item),
                attributes: item.getProperties()
            }
        });
        await DialogObjectInfo.showObjects(
            getMapLayers(this.props.project),
            objects
        );
    }

    handleShowMessage = (message) => {
        DialogObjectInfo.showMessage(message);
    }

    render() {
        return (
            <Stack horizontal verticalFill className={this.classNames.root} tokens={{childrenGap: 0, padding: 5}}>
                {this.renderMap()}
            </Stack>
        );
    }

    renderMap() {
        return (
            <Stack.Item grow className={this.classNames.mapView}>
                <MapInContainer
                    appConfig={this.props.projectDefinition.app}
                    map={this.props.map}
                    mapLayersDefinition={getMapLayers(this.props.project)}
                    mapActions={this.props.mapActions}
                    measurementActions={this.props.measurementActions}
                    onChangeView={this.handleChangeView}
                    onFeatureClick={this.handleFeatureClick}
                    onFeaturesFind={this.handleFeaturesFind}
                    onShowMessage={this.handleShowMessage}
                />
            </Stack.Item>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return {
        appActions: appGetActions(dispatch),
        mapActions: sagasMap.getActions(dispatch),
        measurementActions: sagasMeasurement.getActions(dispatch),
    };
}

function mapStateToProps(state, ownProps) {
    return {
        ...ownProps,
        auth: state.auth,
        project: state.project
    };
}

const ConnectedMapBasicViewer = connect(mapStateToProps, mapDispatchToProps)(MapBasicViewer);

export default ConnectedMapBasicViewer;
